import { useState } from 'react'
import { findCustomProvider } from './customProviders'
import { maskKey } from './maskKey'
import { validateCustomModel } from './validateCustomModel'

const DEFAULT_PROVIDER = 'openai'
const firstModel = (id) => findCustomProvider(id)?.models[0]?.id ?? ''

const seed = (saved) => ({
  provider: saved?.provider ?? DEFAULT_PROVIDER,
  model: saved?.model ?? firstModel(DEFAULT_PROVIDER),
  baseUrl: saved?.baseUrl ?? '',
  apiKey: '',
})

// What gets saved: the key is reduced to a masked hint here and goes no further.
function toSaved(draft, saved) {
  const key = draft.apiKey.trim()
  const next = { provider: draft.provider, model: draft.model.trim(), keyHint: key ? maskKey(key) : saved.keyHint }
  return findCustomProvider(draft.provider)?.baseUrlPlaceholder ? { ...next, baseUrl: draft.baseUrl.trim() } : next
}

/** The Custom model form: fields, errors, and a submit that returns what to save. */
export function useCustomModelDraft(saved) {
  const [draft, setDraft] = useState(() => seed(saved))
  const [errors, setErrors] = useState({})
  const setField = (field, value) => {
    setDraft((current) => ({ ...current, [field]: value }))
    setErrors((current) => ({ ...current, [field]: undefined }))
  }
  // Switching provider resets what belongs to the old one: its model and key.
  const pickProvider = (id) => {
    if (id === draft.provider) return
    setDraft((current) => ({ ...current, provider: id, model: firstModel(id), apiKey: '', baseUrl: '' }))
    setErrors({})
  }
  const submit = () => {
    const found = validateCustomModel(draft, saved)
    setErrors(found)
    return Object.keys(found).length ? null : toSaved(draft, saved)
  }
  return { draft, errors, provider: findCustomProvider(draft.provider), setField, pickProvider, submit }
}
